'use strict';

const $giftsetHowTo = $('.js-product-container-giftset');
const gtm = require('./modules/google').tagManager;

const shouldInit = $giftsetHowTo.length > 0;

const handleImageInteraction = (interactionType) => {
    const analyticsData = $giftsetHowTo.data('analytics');
    if (!analyticsData) {
        return;
    }

    gtm.pushDataLayerEvent({
        event: 'gst',
        interaction: interactionType,
        content_type: 'pdp', /* eslint-disable-line camelcase */
        content_name: analyticsData.productTitle /* eslint-disable-line camelcase */
    });
};

function handleShopOverlay() {
    const $imageZoom = $('.js-click-image-to-zoom');
    const $image = $('.js-how-to-use-image-zoomed');
    const $btnClose = $('.js-product-close');

    $imageZoom.on('click', function (){
        if (!$image.hasClass('image-zoomed')) {
            $image.addClass('image-zoomed');
        } else {
            $image.removeClass('image-zoomed');
        }

        handleImageInteraction('zoom');
    });

    $btnClose.on('click', function (){
        $image.removeClass('image-zoomed');
        handleImageInteraction('exit');
    });
}

function initializeEvents() {
    handleShopOverlay();
}

const giftsetZoom = {
    init: function() {
        if (shouldInit) {
            initializeEvents();
        }
    }
};

module.exports = giftsetZoom;
